<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      СП СП РК 4.02-103-2012<br>
      ПРИЛОЖЕНИЕ В.6<br>
      (обязательное)
    </div>
    <div class="chapter-title">Журнал №: <n-input v-bind="$form.input('journalNumber')" :text="!editable" /></div>
    <div class="chapter-title">
      Журнал по сварке трубных проводок и по сварке трубопроводов системы автоматизации <n-input v-bind="$form.input('addressTitle')" :text="!editable" /> <br>
      (наименование и месторасположение объекта, отделение, корпус)
    </div>
    <div class="chapter-title">
      <n-input v-bind="$form.input('infoOrg')" :text="!editable" /> <br>
      (№ чертежей расположения трубопроводов, буквенно-цифровое обозначение участков)
      (наименование монтажной организации)
    </div>
    <n-items v-if="project">
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
